import * as Sentry from '@sentry/react'; // Or @sentry/node if you want this on the server-side only

const sentryReduxMiddleware = (store) => (next) => (action) => {
  try {
    return next(action);
  } catch (err) {
    console.error('Caught an exception in Redux action!', err);
    Sentry.captureException(err, {
      extra: {
        action,
        state: store.getState(),
      },
    });
    throw err; // Re-throw to allow reducers to handle or for other middleware
  }
};

export default sentryReduxMiddleware;